import type React from 'react';

import { Button } from '@change/ds-core-ui';

import type { PreviewEmailButtonProps } from '../../types';

export const PreviewEmailButton: React.FC<PreviewEmailButtonProps> = ({ disabled, onClick }) => {
	return (
		<Button
			className="w-full md:w-[149px]"
			variant="secondary"
			data-testid="preview-petition-update"
			data-qa="preview-petition-update"
			onClick={onClick}
			type="button"
			disabled={disabled}
			size="small"
		>
			Preview
		</Button>
	);
};
